import MaterialButton from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import MaterialTypography from '@mui/material/Typography';
import { ElementType } from 'react';

import { defaultColors } from '../../../configs/colors';

export const StyledButton = styled(MaterialButton)`
  text-transform: uppercase;
  border-radius: 8px;

  &.extra-small-button {
    padding: 2px 4px 1px 4px;
    font-size: 0.675rem;
    min-width: auto;
    border-radius: 5px;
    line-height: 1.8;
    margin: 2px;
  }
`;

export const StyledText = styled(MaterialTypography)<{
  component?: ElementType;
  type?: string;
  disabled?: boolean;
}>`
  font-family: 'Inter';
  font-size: smaller;
  font-weight: 500;
  cursor: pointer;
  color: ${defaultColors[0]};
  /* Reset the native button chrome this variant now renders with, so it still
     looks like text while being focusable and keyboard-activatable. */
  background: none;
  border: none;
  padding: 0;
  &:disabled {
    cursor: default;
  }
`;
